module.exports = __webpack_public_path__ + "static/media/watercolorsmakemesmile-IG-2.622d482e.PNG";